import { useCallback, useEffect, useState } from "react";
import {
  FounderFinanceDashboardData,
  UpsertFounderFinanceOperatingCostInput,
  fetchFounderFinanceDashboard,
  upsertFounderFinanceOperatingCost
} from "../services/founderFinanceService";

export function useFounderFinance() {
  const [data, setData] = useState<FounderFinanceDashboardData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [saveError, setSaveError] = useState("");
  const [savingCostId, setSavingCostId] = useState<string | null>(null);

  const loadDashboard = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchFounderFinanceDashboard());
    } catch {
      setError("Unable to load Founder Finance dashboard.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadDashboard();
  }, [loadDashboard]);

  const saveCost = useCallback(async (input: UpsertFounderFinanceOperatingCostInput) => {
    setSavingCostId(`${input.monthKey}_${input.category}`);
    setSaveError("");

    try {
      await upsertFounderFinanceOperatingCost(input);
      await loadDashboard();
    } catch {
      setSaveError("Unable to save operating cost. Check admin callable permissions.");
    } finally {
      setSavingCostId(null);
    }
  }, [loadDashboard]);

  return {
    data,
    error,
    isLoading,
    refresh: loadDashboard,
    saveCost,
    saveError,
    savingCostId
  };
}
